import { useParams } from 'react-router-dom';
import type { Language } from '../i18n/language';
import { FALLBACK_LANGUAGE, isLanguage } from '../i18n/languages';

/**
 * The active language, taken from the URL prefix. The URL is the single source of truth: a shared
 * or indexed link must open in the language it was written in, whatever the visitor last chose.
 */
export function useLanguage(): Language {
    const { lang } = useParams<{ lang: string }>();
    return isLanguage(lang) ? lang : FALLBACK_LANGUAGE;
}
